import { Textarea } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';

import { IEventPayloadProps } from '../../utilities/TypeDefs';
import classes from './EventPayload.module.scss';

const EventPayload = (props: IEventPayloadProps) => {
  const { onChange, value, isValidEventPayload, eventPayloadRequired } = props;

  const { t: translate } = useTranslation();

  /**
   * @method errorText
   * @description returns an error string if the event payload format is incorrect
   * @returns string
   */
  const errorText = () => {
    if (!isValidEventPayload) {
      return (translate('job_scheduler_component.txt_invalid_payload'));
    }
    if (eventPayloadRequired) {
      return (translate('job_scheduler_component.txt_required_payload'));
    }
    return ('');
  };

  return (
    <Textarea
      id="payload"
      isMandatory
      labelText={String(translate('job_scheduler_component.lbl_payload'))}
      helperText={String(translate('job_scheduler_component.txt_payload_helper'))}
      value={value}
      onChange={onChange}
      name=""
      placeholder={String(translate('job_scheduler_component.txt_payload_placeholder'))}
      className={classes.textarea}
      data-testid="eventPayload"
      error={!isValidEventPayload || eventPayloadRequired}
      errorTxt={errorText()}
      maxLength={524288}
      infoIconTxt={String(translate('job_scheduler_component.event_payload_info_bubble'))}
    />
  );
};

export default EventPayload;
